<div
	uiDropdown
	[containerSelector]="containerSelector()"
	[fullWidth]="true"
	[useContainerWidth]="useContainerWidth()"
	[ignoreTrigger]="true"
	(openChange)="onDropdownStateChange($event)"
	id="datepicker-input"
>
	<div uiDropdownTrigger [uiDropdownDisabled]="disabled() || hasError()">
		<div class="input-wrapper">
			<div
				class="input pr-0"
				[class]="{
					'input-focused': focused() || dropdownOpened(),
					'input-disabled': disabled(),
					'!input-valid': !hasError() && !invalid() && showWhenValid(),
					'input-error': hasError() || (invalid() && !!displayValue()),
				}"
			>
				<input
					class="input-field"
					[id]="inputId()"
					[placeholder]="placeholder()"
					[value]="displayValue()"
					[disabled]="disabled()"
					(input)="onInput($event)"
					(focusout)="focused.set(false)"
					(focusin)="focused.set(true)"
					(keydown.enter)="$event.preventDefault()"
					#input
				/>
				<ui-button
					type="link-dark"
					icon="cal"
					iconSize="m"
					data-cy="datepicker-input-button"
					[disabled]="disabled()"
					[tabindex]="disabled() ? -1 : 0"
					(buttonClicked)="openCalendar()"
				></ui-button>
			</div>
		</div>
	</div>
	<ng-container *uiDropdownContent>
		<div class="m-6">
			<ui-datepicker-base
				[currentlyDisplayedMonth]="currentlyDisplayedMonth()"
				[disabled]="disabled()"
				[selectedDate]="value()"
				(dateSelectionChange)="calendarSelection($event)"
				(navDateChange)="navDateChange($event)"
				(calendarWeekClicked)="calendarWeekClicked.emit($event)"
				[minDate]="minDate()"
				[maxDate]="maxDate()"
				[excludedDates]="excludedDates()"
				[syncedDate]="syncedDate()"
			></ui-datepicker-base>
		</div>
	</ng-container>
</div>
